import React,{useState, useEffect} from "react";
import normatecaStore from "../../../stores/normatecaStore";

export default function MasInformacion(){
    const imgurl = process.env.REACT_APP_IMG_URL + "normateca/secciones/deinteres/";
    const nasurl= process.env.REACT_APP_NAS + "D_interes/" 
       // store - zuntand
    const { setDeInteres} =
    normatecaStore((state) =>( { 
        setDeInteres: state.setDeInteres,
      })); 
    useEffect(() => { 
        setDeInteres("masInfo").then(function(data){
            setDatos(data);
        })
     },[]);  
    const columnasMF=[
        {
            name: 'Título',
            sortable: true,
            sort:"desc"
        },
        {
        	name: 'Fecha de publicación',
            sortable: true,
            sort:""
       	},
    ]
    const [columnas,setColumnas] = useState(columnasMF);
    const [datos, setDatos] = useState([]);

    const ordena=(colum, orden)=>{
        let datosTemp=[...datos];
        let columnasTemp=[...columnas];
        switch(colum){
            case 0: //título
                datosTemp = orden === "desc"? datosTemp.sort((a,b)=> a.descripcion <  b.descripcion? 1 : -1) : datosTemp.sort((a,b)=> a.descripcion > b.descripcion? 1 : -1) ;
                columnasTemp[0].sort= orden === "desc"?"asc":"desc";
                columnasTemp[1].sort= "desc";
                break;
            case 1: //fecha de publicación
                //console.log("fecha de publicacion",datosTemp[0].fechaPublicacion);
                datosTemp = orden === "desc" || orden===""?  datosTemp.sort((a,b)=> new Date(...b.fechaPublicacion.split('/').reverse()) - new Date(...a.fechaPublicacion.split('/').reverse())) : datosTemp.sort((a,b)=> new Date(...a.fechaPublicacion.split('/').reverse()) - new Date(...b.fechaPublicacion.split('/').reverse())) ;
                columnasTemp[1].sort= orden === "desc"?"asc":"desc";
                columnasTemp[0].sort= "desc";
                break;

        }
        setDatos(datosTemp);
        setColumnas(columnasTemp);
    }
    const abrirURLArch=(url,archivo)=>{
        if(url!==""){window.open(url,'_blank');}
        if(archivo!==""){window.open(nasurl + archivo,'_blank');}
     }
    return(
       <div className="divMasInf">
            <div className="divTit">
                <div className="titpublicRes">Más Información de Interés</div>
                <div className="linepublicRes"></div>
            </div>
            <table className="tablaMasInf">
                <thead>
                    <tr key={"th"}>
                        {columnas.map((col,indexc)=>(
                            col.sortable? 
                                <th key={"cl" + indexc.toString()} className={indexc===1? "width-10rem":""}>
                                        <button type="button" onClick={()=> ordena(indexc,col.sort)} className="btnMasInfo">{col.name }{col.sort==="desc" || col.sort===""?
                                        <span className="inegi-nav-desp vertAlign-text-bottom lineH-n"></span>
                                        :<span className="inegi-nav-despa vertAlign-text-bottom lineH-n"></span>
                                    }
                                    </button>
                                </th> 
                            : <td key={"cl" + indexc.toString()}>{col.name}</td>
                        )
                        )}
                    </tr>
                </thead>
                <tbody>
                    {datos?.map((dat,index)=>(
                        index>=0? <tr key={"i" + index.toString()}>
                            <td>
                                <a onClick={()=>abrirURLArch(dat.url? dat.url:"",dat.archivo)} target="_blank"className="color-blue cursor-pointer">
                                    <img src={imgurl +  dat.img} className="imgMasInfo"/><label> {dat.descripcion} </label>
                                </a>
                            </td>
                            <td className="txt-align-center">{dat.fechaPublicacion}</td>
                        </tr>
                        : null
                    ))}
                </tbody>
            </table>
       </div>


	
		
    )
}